enum Element_Type {
  term,
  definition,
}

export default Element_Type;
